import { IInputRuleBehavior } from "./IInputRuleBehavior";

export interface IInputRuleBehaviorSpecifiable {
  inputRuleBehavior: IInputRuleBehavior;
}

export function instanceOfIInputRuleBehaviorSpecifiable(instance: any): instance is IInputRuleBehaviorSpecifiable {
  return instance
    && (instance.inputRuleBehavior !== undefined);
}
